import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';
// material
import { styled, alpha } from '@mui/material/styles';
import {
  Box,
  Button,
  Drawer,
  Typography,
  Avatar,
  Collapse,
  Tooltip,
  IconButton,
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  CircularProgress
} from '@mui/material';
// mocks_
// hooks
import useResponsive from '../../hooks/useResponsive';

// components
import Scrollbar from '../../components/Scrollbar';
import NavSection from '../../components/NavSection';
//
import Iconify from '../../components/Iconify';
import { api } from 'src/Api';
import { Decryption } from 'src/functions/function';
import palette from '../../theme/palette';
import { ExpandLess, ExpandMore } from '@mui/icons-material';

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 240;

const RootStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    flexShrink: 0,
    width: DRAWER_WIDTH,
    backgroundColor: alpha(theme.palette.drawerBackground, 1)
  }
}));

const AccountStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12]
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func
};

const sideBarData = [
  {
    icon: 'tabler:home',
    id: 1,
    path: '/dashboard',
    permission_name: 'Dashboard',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [],
    title: 'Dashboard'
  },
  {
    icon: 'tabler:home',
    id: 2,
    path: '/roles',
    permission_name: 'Role/Permissions',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [],
    title: 'Role/Permissions'
  },
  {
    icon: 'lucide:file-edit',
    id: 1,
    path: '/compliance-setup',
    permission_name: 'Compliance Setup',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/compliance-setup/cash-accounts',
        permission_name: 'Cash Accounts',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Cash Accounts'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/compliance-setup/principal-balances-setup',
        permission_name: 'Principal Balances Setup',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Principal Balances Setup'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/compliance-setup/haircut-setup',
        permission_name: 'Haircut Setup',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Haircut Setup'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/compliance-setup/recovery-rate-setup',
        permission_name: 'Recovery Rate Setup',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Recovery Rate Setup'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/compliance-setup/ratings-setup',
        permission_name: 'Ratings Setup',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Ratings Setup'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/compliance-setup/test-setup',
        permission_name: 'Test Setup',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Test Setup'
      }
    ],
    title: 'Compliance Setup'
  },
  {
    icon: 'lucide:briefcase-business',
    id: 1,
    path: '/deal-information',
    permission_name: 'Deal Information',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/deal-information/liabilities',
        permission_name: 'Liabilities',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Liabilities'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/deal-information/test-results',
        permission_name: 'Test Results',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Test Results'
      }
    ],
    title: 'Deal Information'
  },
  {
    icon: 'iconoir:cash',
    id: 1,
    path: '/cash',
    permission_name: 'Cash',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/cash/cash-transactions',
        permission_name: 'Cash Transactions',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Cash Transactions'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/cash/cash-balances',
        permission_name: 'Cash Balances',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Cash Balances'
      }
    ],
    title: 'Cash'
  },
  {
    icon: 'basil:invoice-outline',
    id: 1,
    path: '/holdings',
    permission_name: 'Holdings',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [],
    title: 'Holdings'
  },
  {
    icon: 'lets-icons:calendar',
    id: 1,
    path: '/report-calendar',
    permission_name: 'Report Calendar',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [],
    title: 'Report Calendar'
  },
  {
    icon: 'lets-icons:setting-line',
    id: 1,
    path: '/settings',
    permission_name: 'Settings',
    permission_types: [
      {
        created_at: '2025-04-14T11:01:24.000000Z',
        deleted_at: null,
        id: 1,
        permission_id: 1,
        permission_type_id: 1,
        permission_type_name: 'Visible',
        role_id: 1,
        status: 'active',
        updated_at: '2025-04-14T11:01:24.000000Z'
      }
    ],
    subRoutes: [
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/settings/audit-log',
        permission_name: 'Audit Log',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Audit Log'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/settings/workflow',
        permission_name: 'Workflow',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'Workflow'
      },
      {
        icon: 'eva:pie-chart-2-fill',
        id: 1,
        path: '/settings/list-of-deals',
        permission_name: 'List of Deals',
        permission_types: [
          {
            created_at: '2025-04-14T11:01:24.000000Z',
            deleted_at: null,
            id: 1,
            permission_id: 1,
            permission_type_id: 1,
            permission_type_name: 'Visible',
            role_id: 1,
            status: 'active',
            updated_at: '2025-04-14T11:01:24.000000Z'
          }
        ],
        title: 'List of Deals'
      }
    ],
    title: 'Settings'
  }
];

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();
  const user = JSON.parse(localStorage.getItem('user'));
  const navigate = useNavigate();
  const isDesktop = useResponsive('up', 'lg');
  const [open, setOpen] = useState(false);
  const [sideBar, setsideBar] = useState([]);
  const [loading, setLoading] = useState(false);

  const [projectsList, setProjectsList] = useState([]);
  const [selectedPortfolio, setSelectedPortfolio] = useState('');

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  function Logout() {
    const rememberEmail = localStorage.getItem('email');
    const rememberPassword = localStorage.getItem('password');
    const rememberMe = localStorage.getItem('remember');

    // Clear all local storage
    localStorage.clear();

    // Re-set remembered credentials
    if (rememberMe === 'true') {
      localStorage.setItem('email', rememberEmail);
      localStorage.setItem('password', rememberPassword);
      localStorage.setItem('remember', rememberMe);
    }

    navigate('/', { replace: true });
  }

  const handleProfileClick = () => {
    setOpen(!open);
  };

  // function getProjects() {
  //   const token = localStorage.getItem('token');
  //   const myHeaders = new Headers();
  //   myHeaders.append('Authorization', `Bearer ${token}`);

  //   const requestOptions = {
  //     method: 'GET',
  //     redirect: 'follow',
  //     headers: myHeaders
  //   };

  //   fetch(api.get_projects, requestOptions)
  //     .then((response) =>
  //       response.text().then((result) => ({ status: response.status, body: result }))
  //     )
  //     .then(({ status, body }) => {
  //       const result = JSON.parse(body);
  //       if (status === 200 || status === 201) {
  //         setProjectsList(result?.data);
  //       } else {
  //         console.log(result.error);
  //       }
  //     })
  //     .catch((error) => {
  //       console.log('error', error);
  //     });
  // }

  const savedPortfolio = localStorage.getItem('selectedPortfolio');

  function getSideBar() {
    setLoading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);
    const savedPortfolio = localStorage.getItem('selectedPortfolio');

    const queryParams = new URLSearchParams();
    savedPortfolio && queryParams.append('project_id', savedPortfolio);

    var requestOptions = {
      method: 'GET',
      headers: myHeaders,

      redirect: 'follow'
    };

    fetch(`${api.sideBar}?${queryParams.toString()}`, requestOptions)
      .then((response) => {
        if (response.status === 200) {
          return response.json();
        } else {
          throw new Error('Failed to fetch sidebar data');
        }
      })
      .then((result) => {
        let decryptedData = Decryption(result.data);
        setsideBar(decryptedData);
        localStorage.setItem('permissions', JSON.stringify(decryptedData));
      })
      .catch((error) => {
        console.log('error', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (user?.role?.id !== 2) {
      // getProjects();
    }
    // if (savedPortfolio) {
    getSideBar();
    // }
  }, [savedPortfolio]);

  useEffect(() => {
    if (projectsList.length > 0) {
      const savedPortfolio = localStorage.getItem('selectedPortfolio');
      if (!savedPortfolio || savedPortfolio == '1') {
        const firstPortfolioId = projectsList[0]?.id;
        setSelectedPortfolio(firstPortfolioId);
        localStorage.setItem('selectedPortfolio', firstPortfolioId);
      } else {
        setSelectedPortfolio(savedPortfolio);
      }
    }
  }, [projectsList]);

  const handlePortfolioChange = (event) => {
    const newPortfolioId = event.target.value;
    setSelectedPortfolio(newPortfolioId);
    localStorage.setItem('selectedPortfolio', newPortfolioId);
    window.location.reload();
  };

  const renderContent = (
    <Box
      sx={{
        height: 1,
        pt: 1,
        background: '#373537',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', px: 1 }}>
        <Box
          component="img"
          sx={{
            width: 160,
            height: 80,
            marginLeft: 1,
            paddingLeft: 0
          }}
          src={process.env.REACT_APP_LOGO}
          alt="Logo"
        />
      </Box>

      {/* Portfolio Dropdown */}
      {/* {(user?.role?.id !== 2 || user?.is_nexus !== '0') && (
        <FormControl fullWidth size="small" sx={{ mb: 1, px: 1 }}>
          <Select
            value={selectedPortfolio} 
            onChange={handlePortfolioChange} // Handle change
            variant="outlined"
            disabled={projectsList.length == 0}
            sx={{
              color: '#fff',
              borderRadius: 0.5,
              fontSize: 12,
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: palette.primary.main,
                borderWidth: '1.5px'
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: projectsList.length == 0 ? '#e7c873' : palette.primary.main
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: palette.primary.main,
                borderWidth: '1.5px'
              },
              '& .MuiSvgIcon-root': {
                color: '#fff'
              }
            }}
            input={<OutlinedInput />}
            MenuProps={{
              PaperProps: {
                sx: {
                  borderRadius: 0.5,
                  ml: -1
                }
              }
            }}
          >
            {projectsList.map((option, index) => (
              <MenuItem key={index} value={option?.id} sx={{ fontSize: 12 }}>
                {option?.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      )} */}
      {/* Nav Items */}
      <Scrollbar
        sx={{
          flex: 1,
          px: 1,
          mt: 1,
          ml: 1,
          '& .simplebar-content': {
            display: 'flex',
            flexDirection: 'column'
          }
        }}
      >
        {loading ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              height: '100%',
              mt: 2
            }}
          >
            <CircularProgress sx={{ color: palette.primary.main }} size={20} />
          </Box>
        ) : (
          <Box
            sx={{
              pb: 3,
              '& .nav-item': {
                borderRadius: 1,
                mb: 0.5,
                transition: 'all 0.2s ease-in-out',
                '&:hover': {
                  backgroundColor: alpha(palette.primary.main, 0.1)
                },
                '&.active': {
                  backgroundColor: alpha(palette.primary.main, 0.2),
                  '& .MuiTypography-root': {
                    color: palette.primary.main,
                    fontFamily: 'poppinsMedium'
                  },
                  '& .iconify': {
                    color: palette.primary.main
                  }
                }
              },
              '& .MuiListItemButton-root': {
                borderRadius: 1,
                py: 0.75,
                px: 2,
                '&:hover': {
                  backgroundColor: alpha(palette.primary.main, 0.1)
                },
                '&.active': {
                  backgroundColor: alpha(palette.primary.main, 0.2)
                }
              },
              '& .MuiTypography-root': {
                fontSize: 13,
                fontFamily: 'poppinsRegular',
                color: palette.primary.white,
                transition: 'all 0.2s ease-in-out'
              },
              '& .iconify': {
                color: palette.primary.white,
                transition: 'all 0.2s ease-in-out'
              }
            }}
          >
            <NavSection navConfig={sideBar} />
          </Box>
        )}
      </Scrollbar>
      {/* User Profile */}
      {user && (
        <Box
          sx={{
            pt: 1,
            pb: 1,
            px: 1,
            backgroundColor: palette.primary.secondaryMainLighter,
            borderTop: 1,
            borderColor: palette.primary.main
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              cursor: 'pointer',
              width: '100%'
            }}
            onClick={handleProfileClick}
          >
            <Avatar
              src={user?.avatar}
              sx={{
                width: 30,
                height: 30,
                mr: 1,
                borderRadius: 10,
                border: 2,
                borderColor: palette.primary.main
              }}
            />
            <Box sx={{ width: 140, maxWidth: 140 }}>
              <Typography
                sx={{
                  fontSize: 11,
                  fontFamily: 'poppinsMedium',
                  color: palette.primary.white,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {`${user?.firstname} ${user?.lastname}`}
              </Typography>
              <Typography
                sx={{
                  fontSize: 9,
                  fontFamily: 'poppinsRegular',
                  color: palette.primary.white,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}
              >
                {user?.email}
              </Typography>
            </Box>
            {open ? (
              <ExpandLess sx={{ color: palette.primary.white, fontSize: 15 }} />
            ) : (
              <ExpandMore sx={{ color: palette.primary.white, fontSize: 15 }} />
            )}
          </Box>

          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box mt={1}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Button
                  variant="contained"
                  size="small"
                  component={RouterLink}
                  to="my-account"
                  sx={{
                    height: 30,
                    fontSize: 10,
                    flex: 1,
                    fontFamily: 'poppinsLight',
                    letterSpacing: 0.6,
                    borderRadius: 0.5
                  }}
                >
                  My Account
                </Button>

                <Tooltip title="Log Out" arrow>
                  <IconButton
                    size="small"
                    onClick={Logout}
                    sx={{
                      ml: 1,
                      border: `1.5px solid ${palette.primary.main}`,
                      borderRadius: 0.7
                    }}
                  >
                    <Iconify
                      icon="majesticons:logout"
                      sx={{ color: palette.primary.main, fontSize: 17 }}
                    />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>
          </Collapse>
        </Box>
      )}
    </Box>
  );

  return (
    <RootStyle>
      {!isDesktop && (
        <Drawer
          open={isOpenSidebar}
          onClose={onCloseSidebar}
          PaperProps={{
            sx: { width: DRAWER_WIDTH, bgcolor: 'background.default' }
          }}
        >
          {renderContent}
        </Drawer>
      )}

      {isDesktop && (
        <Drawer
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: DRAWER_WIDTH,
              bgcolor: 'background.default',
              boxShadow: 'none'
            }
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </RootStyle>
  );
}
